/* Schnellansicht-Dialog des Themes.
   Aus dem Inline-<script> von snippets/quick-view.liquid ausgelagert (2026-07-31).
   Grund: das Snippet rendert einmal im Layout, das Skript stand damit als 31.6 KiB
   im Dokument JEDER Seite — unkomprimiert im render-blockierenden Pfad und bei
   jedem Seitenaufruf erneut. Als Asset wird es von Shopify minifiziert, ist
   zwischenspeicherbar und faellt aus dem Dokument heraus.

   `defer` ist unbedenklich: das Skript fragt sein Wurzelelement mit
   document.querySelector ab und steigt aus, wenn es fehlt. Als Inline-Skript lief es
   waehrend des Parsens (das Markup steht darueber), mit `defer` nach dem Parsen —
   also mit MEHR Dokument, nicht weniger. Gleiche Begruendung wie beim Menue-Umzug
   am 30.07. (blocks/menu.liquid).
*/
(function () {
  if (window.__neQuickViewInit) return;
  window.__neQuickViewInit = true;

  var dialog = document.querySelector('[data-quick-view-modal]');
  if (!dialog) return;

  var body = dialog.querySelector('[data-quick-view-body]');
  var closeBtn = dialog.querySelector('[data-quick-view-close]');
  var loadingHTML = body.innerHTML; /* spinner — restored on next open */
  var qvErrorLabel = dialog.getAttribute('data-i18n-error') || 'Could not load product.';
  var qvViewFullLabel = dialog.getAttribute('data-i18n-view-full') || 'View full details';

  var productCache = {}; /* handle → { json, sectionHTML } */
  var currentProduct = null; /* full product JSON object */
  var currentVariants = null; /* parsed variants array */

  /* Base surface set in Liquid from quick_view_surface — kept so inherit-card
     mode can restore it on close. Custom-scheme mode carries a static
     color-scheme-N class from Liquid (untouched here). */
  var qvBaseSurface = dialog.getAttribute('data-surface') || 'solid';

  /* ---- Frame weld (opt-in, quick_view_connect_frame; left/right slide-in only) --
     Mirrors the cart-drawer weld JS: drives the SHARED --ne-drawer-edge so the
     panel slide and the frame's edge retreat move in lockstep, and insets the
     ::backdrop past the header. Reuses --ne-drawer-* / --ne-cart-ov-* (the QV and
     cart drawer are never open at the same time). */
  var qvWeld = dialog.classList.contains('ne-quick-view--weld');
  /* Edge-effect element for the side welds — lives OUTSIDE the dialog on purpose (see
     the CSS): it has to be in the normal flow, below the frame and behind the backdrop,
     which nothing inside a top-layer <dialog> can be. Only rendered when the frame
     actually carries a glow or shadow, so a null here is the normal "effect off" state. */
  var qvFxEl = document.querySelector('[data-quick-view-weld-fx]');
  var qvVarCleanupTimer = null;
  var qvSide = 'right';
  ['left', 'right', 'top', 'bottom'].forEach(function (s) {
    if (dialog.classList.contains('ne-quick-view--side-' + s)) qvSide = s;
  });
  /* Top/bottom slide on the Y axis: --ne-drawer-edge then carries the panel's HEIGHT,
     and the frame's top/bottom edge is what retreats. */
  var qvVertical = (qvSide === 'top' || qvSide === 'bottom');
  var qvRoot = document.documentElement;
  var qvCloseTimer = null;
  /* Resting panel width in px — the FRAME's travel distance (the panel itself parks
     via `100%`, see the CSS). offsetWidth is transform-independent, so it is the
     resting width even while the panel is translated off-screen. Right after
     showModal() it can still read 0 (no layout for the freshly-shown dialog yet);
     the rect/computed-width fallbacks cover that, and a 0 result keeps the open-slide
     pending so qvStartOpenSlide can re-measure once the content is in. */
  function qvPanelW() {
    var box = qvVertical ? 'Height' : 'Width';
    var w = Math.round(qvVertical ? dialog.offsetHeight : dialog.offsetWidth);
    if (!w) w = Math.round(dialog.getBoundingClientRect()[qvVertical ? 'height' : 'width']);
    if (!w) w = Math.round(parseFloat(getComputedStyle(dialog)[box.toLowerCase()]) || 0);
    return Math.max(0, w);
  }

  /* Write the frame's travel distance + run the edge 0→w, which slides the panel in
     AND retreats the frame edge in lockstep (one interpolating var, CSS transition on
     :root). Split out so both the immediate open (applyQVWeld) and the deferred one
     (qvStartOpenSlide, when the width wasn't measurable yet) share it. */
  function qvRunOpenSlide(w) {
    qvPendingOpenSlide = false;
    /* --ne-qv-p runs on EVERY side: vertical panels ride it for the whole slide, and on
       all four it grows the concave fillet 0 → full radius so the weld forms during the
       opening instead of appearing finished (nav-dropdown behaviour, menu-styles.liquid). */
    if (qvVertical) {
      requestAnimationFrame(function () { dialog.style.setProperty('--ne-qv-p', '1'); });
      return;
    }
    qvRoot.style.setProperty('--ne-drawer-w', w + 'px');
    requestAnimationFrame(function () {
      qvRoot.style.setProperty('--ne-drawer-edge', w + 'px');
      dialog.style.setProperty('--ne-qv-p', '1');
    });
  }

  /* Fallback path: the width wasn't measurable at showModal time. The panel is parked
     off-screen (CSS `100%`) either way, so this only decides WHEN the slide runs —
     re-measure once injectAndWire has put the content in. */
  var qvPendingOpenSlide = false;
  function qvStartOpenSlide() {
    if (!qvPendingOpenSlide) return;
    if (qvVertical) { qvRunOpenSlide(0); return; } /* progress-driven, nothing to measure */
    var w = qvPanelW();
    if (!w) { qvPendingOpenSlide = false; return; } /* nothing sane to animate to */
    qvRunOpenSlide(w);
  }

  /* Slide duration — drawer_slide_speed, with the nav speed as legacy fallback.
     Must match the :root --ne-drawer-edge transition, otherwise the close timer
     display:none's the dialog mid-slide (or leaves it hanging after it). */
  function qvDrawerSpeed() {
    var cs = getComputedStyle(qvRoot);
    return parseFloat(cs.getPropertyValue('--ne-drawer-speed')) ||
           parseFloat(cs.getPropertyValue('--ne-dropdown-speed')) || 280;
  }

  /* Mirrors the burger drawer weld's applyDrawerWeld EXACTLY (also a <dialog> +
     showModal, edge-driven). Called SYNCHRONOUSLY right after showModal() — same
     task, so it runs before the first paint: the panel first-paints with the right
     top + parked off-screen (edge=0 → translateX(±w)), no jump. qvStartOpenSlide then
     sets edge=w so the panel slides in AND the frame edge retreats in lockstep (both
     are functions of the single interpolating --ne-drawer-edge on :root). */
  function applyQVWeld() {
    if (!qvWeld) return;
    if (qvCloseTimer) { clearTimeout(qvCloseTimer); qvCloseTimer = null; }
    /* A deferred cleanup from the previous close must not fire into this open and strip
       the rect vars we are about to measure (see finalizeQVWeld). */
    if (qvVarCleanupTimer) { clearTimeout(qvVarCleanupTimer); qvVarCleanupTimer = null; }
    var vw = window.innerWidth, vh = window.innerHeight;
    /* Runs SYNCHRONOUSLY after showModal(), i.e. before the first paint — the panel
       first-paints parked off-screen at translateX(±100%) via the [open] weld rule,
       no jump, no inline transform needed. */
    qvRoot.style.setProperty('--ne-drawer-edge', '0px'); // start off-screen
    var w = qvPanelW();
    var frameEl = document.querySelector('.ne-layer-frame');
    var frameTop = 0, frameInset = 8;
    if (frameEl) {
      var fr = frameEl.getBoundingClientRect();
      frameTop = Math.max(0, Math.round(fr.top));
      frameInset = Math.max(0, Math.round(vh - fr.bottom));
      qvRoot.style.setProperty('--ne-drawer-frame-inset', frameInset + 'px');
      var frameCS = getComputedStyle(frameEl);
      qvRoot.style.setProperty('--ne-drawer-frame-radius', frameCS.borderTopLeftRadius);
      /* No frame-glow mirroring here (attempted + removed 2026-07-24): the panel is a
         modal <dialog>, so its ::backdrop sits in the top layer above the frame and
         washes the frame's inward glow out. Re-painting that glow inside the top layer
         worked mechanically, but with frame_style: area the effect colour IS the band's
         own fill (rgb(31,22,41) in the test store) — over the bright blurred mulde that
         reads as a black line, not as a glow. The cart and burger drawers have the same
         glow-under-overlay behaviour; the quick view now matches them. */
    }
    var drawerTop = frameTop, ovTop = frameTop, ovLeft = frameInset, ovRight = frameInset, ovBottom = frameInset;
    var hdr = document.querySelector('.ne-header');
    if (hdr) {
      var hb = hdr.getBoundingClientRect();
      var topBar = hb.width >= vw * 0.6 && hb.bottom <= vh * 0.5;
      var leftBar = hb.height >= vh * 0.6 && hb.right <= vw * 0.5;
      var rightBar = hb.height >= vh * 0.6 && hb.left >= vw * 0.5;
      if (topBar) { drawerTop = Math.max(drawerTop, Math.round(hb.bottom)); ovTop = drawerTop; }
      if (leftBar) ovLeft = Math.max(ovLeft, Math.round(hb.right));
      if (rightBar) ovRight = Math.max(ovRight, Math.round(vw - hb.left));
    }
    qvRoot.style.setProperty('--ne-drawer-top', drawerTop + 'px');
    qvRoot.style.setProperty('--ne-cart-ov-top', ovTop + 'px');
    qvRoot.style.setProperty('--ne-cart-ov-left', ovLeft + 'px');
    qvRoot.style.setProperty('--ne-cart-ov-right', ovRight + 'px');
    qvRoot.style.setProperty('--ne-cart-ov-bottom', ovBottom + 'px');
    /* The directional class is what makes the frame's edge retreat — only correct for
       the full-height side panels. A top/bottom panel keeps the floating card's width,
       so a retreating edge would pull the whole wall back for a card that covers only
       its middle. Those get the base class alone (backdrop insets), frame untouched. */
    document.body.classList.add('ne-drawer-open');
    if (!qvVertical) document.body.classList.add('ne-drawer-open--' + qvSide);
    /* Show the edge effect from the same task, i.e. before the first paint: it is parked
       off-screen with the panel (both read --ne-drawer-edge = 0) and slides in with it. */
    if (qvFxEl && !qvVertical) qvFxEl.classList.add('is-on');
    /* Slide in immediately (one rAF after edge=0 commits) — 1:1 the cart drawer. The
       panel slides while the spinner shows and the content lands behind it, exactly
       like the cart drawer filling in its lines. Only if the width wasn't measurable
       yet do we defer to qvStartOpenSlide (called from every injectAndWire path). */
    qvPendingOpenSlide = true;
    dialog.style.setProperty('--ne-qv-p', '0'); /* parked + fillet at 0, before first paint */
    if (qvVertical || w) qvRunOpenSlide(w);
    setTimeout(qvStartOpenSlide, 800); /* safety: never leave the panel parked off-screen if a content path forgets to trigger */
  }

  function finalizeQVWeld() {
    if (!qvWeld) return;
    document.body.classList.remove('ne-drawer-open', 'ne-drawer-open--left', 'ne-drawer-open--right',
                                   'ne-drawer-open--top', 'ne-drawer-open--bottom');
    qvPendingOpenSlide = false;
    dialog.style.removeProperty('--ne-qv-p');
    /* Hidden only here, i.e. AFTER the out-slide (finalize runs from resetQVAfterClose,
       behind the close timer) — pulling it at the start of the close would drop the seam
       effect while the panel is still on its way out. */
    if (qvFxEl) qvFxEl.classList.remove('is-on');
    /* ⚠️ The variable cleanup has to OUTLIVE the dialog's close. dialog.close() does not
       take the ::backdrop away immediately — `transition: overlay/display allow-discrete`
       keeps it in the top layer for the exit, and the backdrop is fully opaque the whole
       time (nothing fades it). Its rect is built from exactly these vars, so removing
       them here snapped it to the static Liquid fallbacks, which know the frame inset but
       NOT the header strip: the blur jumped over the header for the length of the exit
       (user 2026-07-25). Deferred past the transition, the backdrop keeps its measured
       rect until it is actually gone. Cleared in applyQVWeld so a fast re-open can never
       have this wipe the fresh values out from under it. */
    if (qvVarCleanupTimer) clearTimeout(qvVarCleanupTimer);
    qvVarCleanupTimer = setTimeout(function () {
      qvVarCleanupTimer = null;
      ['--ne-drawer-edge', '--ne-drawer-w', '--ne-drawer-top', '--ne-drawer-frame-inset', '--ne-drawer-frame-radius',
       '--ne-cart-ov-top', '--ne-cart-ov-left', '--ne-cart-ov-right', '--ne-cart-ov-bottom']
        .forEach(function (p) { qvRoot.style.removeProperty(p); });
    }, qvDrawerSpeed() + 60);
  }

  /* Weld: slide the panel out (edge → 0, frame returns in lockstep) BEFORE the
     native close, so the dialog isn't display:none'd mid-slide. All close paths
     route through this. Non-weld closes immediately. */
  /* Full reset after a close — split out so the weld path can DEFER it until the
     out-slide finishes (clearing --ne-drawer-w / --ne-drawer-edge mid-slide would
     kill both the panel + frame exit animations). */
  function resetQVAfterClose() {
    finalizeQVWeld();
    body.innerHTML = loadingHTML;
    currentProduct = null;
    currentVariants = null;
    if (dialog.hasAttribute('data-qv-inherit-card')) {
      dialog.className = dialog.className
        .replace(/\bcolor-scheme-[^\s]+/g, '')
        .replace(/\s+/g, ' ')
        .trim();
      dialog.removeAttribute('data-original-scheme');
      dialog.setAttribute('data-surface', qvBaseSurface);
    }
  }

  function closeQV() {
    if (qvWeld && (dialog.open || dialog.hasAttribute('open'))) {
      /* Slide out (keep [open] so the [open] weld transform rule AND the backdrop stay
         live through the slide): edge → 0 retreats the panel off-screen and brings the
         frame edge back, in lockstep — the exact mirror of the open direction and 1:1
         the cart drawer's closeDrawer. Close + reset AFTER the slide so the dialog
         isn't display:none'd mid-slide (mirrors the burger weld's requestClose).
         'close' fires from inside the timer while qvCloseTimer is still truthy, so its
         handler no-ops and the reset runs here. */
      qvPendingOpenSlide = false; /* a pending open-slide must not fire mid-close */
      dialog.style.setProperty('--ne-qv-p', '0'); /* panel (vertical) + fillet retract */
      if (!qvVertical) qvRoot.style.setProperty('--ne-drawer-edge', '0px');
      if (qvCloseTimer) clearTimeout(qvCloseTimer);
      qvCloseTimer = setTimeout(function () {
        dialog.close();
        resetQVAfterClose();
        qvCloseTimer = null;
      }, qvDrawerSpeed() + 40);
    } else {
      dialog.close();
    }
  }

  /* When the modal mirrors the clicked card (quick_view_inherit_card on,
     custom-scheme off), copy the card's colour scheme + surface onto the
     dialog. Colour-scheme priority custom > card > global is enforced in
     Liquid: the inherit flag is only present when custom is off. */
  function applyCardAppearance(trigger) {
    /* Colour scheme: nearest ancestor carrying a color-scheme-N class. */
    dialog.className = dialog.className
      .replace(/\bcolor-scheme-[^\s]+/g, '')
      .replace(/\s+/g, ' ')
      .trim();
    dialog.removeAttribute('data-original-scheme'); /* let applyMode re-derive */
    var schemeEl = trigger.closest('[class*="color-scheme-"]');
    if (schemeEl) {
      var m = schemeEl.className.match(/color-scheme-[A-Za-z0-9-]+/);
      if (m) dialog.classList.add(m[0]);
    }
    /* Surface: the card emits data-qv-surface (glass / transparent / solid).
       Cards have no tint concept, so clear any select-driven tint flag. */
    var surface = trigger.getAttribute('data-qv-surface') || 'solid';
    dialog.setAttribute('data-surface', surface);
    dialog.removeAttribute('data-qv-tint');
  }

  /* Click delegation: any [data-quick-view][data-product-handle] in the
     document opens the modal for that product. */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-quick-view][data-product-handle]');
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = trigger.getAttribute('data-product-handle');
    if (!handle) return;
    if (dialog.hasAttribute('data-qv-inherit-card')) {
      applyCardAppearance(trigger);
    }
    openQuickView(handle);
  }, true); /* capture-phase so we beat the parent <a> click */

  closeBtn.addEventListener('click', function () { closeQV(); });

  /* Native dialog: click on backdrop closes. Detect by checking
     whether click target is the dialog element itself (backdrop is
     part of dialog's hit-region in browsers that support ::backdrop). */
  dialog.addEventListener('click', function (e) {
    if (e.target === dialog) closeQV();
  });

  /* ESC (native dialog cancel) → animate the weld slide-out instead of the
     instant native close; non-weld keeps the native behaviour. */
  dialog.addEventListener('cancel', function (e) {
    if (qvWeld) { e.preventDefault(); closeQV(); }
  });

  /* Reset the modal body on close so the spinner shows again on the next open. */
  dialog.addEventListener('close', function () {
    /* Weld close routes through closeQV(), which slid the panel + frame out first
       and scheduled resetQVAfterClose() for AFTER the slide — resetting here (fires
       synchronously with dialog.close(), before the slide) would clear the vars
       mid-animation. Non-weld closes reset immediately. */
    if (qvWeld && qvCloseTimer) return;
    resetQVAfterClose();
  });

  function openQuickView(handle) {
    body.innerHTML = loadingHTML;
    if (!dialog.open) { dialog.showModal(); applyQVWeld(); }

    if (productCache[handle]) {
      injectAndWire(productCache[handle], handle);
      return;
    }

    Promise.all([
      fetch('/products/' + encodeURIComponent(handle) + '.js').then(function (r) { return r.json(); }),
      fetch('/products/' + encodeURIComponent(handle) + '?section_id=quick-view').then(function (r) { return r.text(); })
    ]).then(function (results) {
      var data = { json: results[0], sectionHTML: results[1] };
      productCache[handle] = data;
      injectAndWire(data, handle);
    }).catch(function () {
      body.innerHTML = '<div style="padding: 40px 24px; text-align: center;">' +
        '<p>' + qvErrorLabel + '</p>' +
        '<a href="/products/' + encodeURIComponent(handle) + '" class="ne-qv__view-full">' + qvViewFullLabel + ' →</a></div>';
      qvStartOpenSlide();
    });
  }

  function injectAndWire(data, handle) {
    /* The section endpoint returns a wrapped .shopify-section element
       containing our .ne-quick-view-section. Parse it and grab the
       inner section markup only. */
    var parser = new DOMParser();
    var doc = parser.parseFromString(data.sectionHTML, 'text/html');
    var section = doc.querySelector('.ne-quick-view-section');
    if (!section) {
      body.innerHTML = '<div style="padding: 40px;">' + qvErrorLabel + '</div>';
      qvStartOpenSlide();
      return;
    }
    body.innerHTML = '';
    body.appendChild(section);

    /* Cache full product + variants for swatch + image-swap handlers */
    currentProduct = data.json;
    var variantsScript = section.querySelector('[data-qv-variants-json]');
    try { currentVariants = variantsScript ? JSON.parse(variantsScript.textContent) : data.json.variants; }
    catch (e) { currentVariants = data.json.variants; }

    wireSwatches(section);
    wireQuantity(section);
    wireForm(section, handle);
    wireThumbs(section);
    wireNav(section);
    preloadGalleryImages(section);
    qvStartOpenSlide(); /* content is in + wired → now slide the panel in (settled start) */
  }

  /* Preload all gallery full-size images so subsequent thumb/variant
     swaps swap-in instantly (browser fetches them in parallel while
     user reads the info block). */
  function preloadGalleryImages(section) {
    var thumbs = section.querySelectorAll('[data-qv-thumb]');
    thumbs.forEach(function (t) {
      var src = t.getAttribute('data-qv-full');
      if (!src) return;
      var preImg = new Image();
      preImg.src = src;
    });
  }

  /* Prev/next chevron nav cycles through thumbs (clamped, no wrap). */
  function wireNav(section) {
    var prev = section.querySelector('[data-qv-prev]');
    var next = section.querySelector('[data-qv-next]');
    if (!prev && !next) return;
    var thumbs = section.querySelectorAll('[data-qv-thumb]');
    var primaryImg = section.querySelector('.ne-qv__primary-img');
    if (!thumbs.length || !primaryImg) return;

    function currentIdx() {
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].classList.contains('ne-qv__thumb--active')) return i;
      }
      return 0;
    }
    function activate(i) {
      if (i < 0) i = 0;
      if (i >= thumbs.length) i = thumbs.length - 1;
      thumbs.forEach(function (t) {
        t.classList.remove('ne-qv__thumb--active');
        t.setAttribute('aria-selected', 'false');
      });
      thumbs[i].classList.add('ne-qv__thumb--active');
      thumbs[i].setAttribute('aria-selected', 'true');
      swapPrimary(primaryImg, thumbs[i].getAttribute('data-qv-full'), true);
      thumbs[i].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      updateNavDisabled();
    }
    function updateNavDisabled() {
      var idx = currentIdx();
      if (prev) prev.disabled = idx <= 0;
      if (next) next.disabled = idx >= thumbs.length - 1;
    }
    if (prev) prev.addEventListener('click', function () { activate(currentIdx() - 1); });
    if (next) next.addEventListener('click', function () { activate(currentIdx() + 1); });
    updateNavDisabled();
  }

  /* Swap primary <img>: replace src + srcset so srcset doesn't override
     the new src on responsive resize. Image-tag emits both. */
  function swapPrimary(imgEl, fullSrc, animate) {
    if (!imgEl || !fullSrc) return;
    /* Instant swap — no view transition here. The quick view is a top-layer
       <dialog> (showModal), and cross-fading an element inside the top layer
       makes the snapshot land mis-placed (a stray "popup" of the image). The
       in-page cross-fade therefore stays on the product gallery + both
       lightboxes, where it renders cleanly. (animate param kept for callers.) */
    imgEl.removeAttribute('srcset');
    imgEl.removeAttribute('sizes');
    imgEl.src = fullSrc;
  }

  function wireThumbs(section) {
    var thumbs = section.querySelectorAll('[data-qv-thumb]');
    var primaryImg = section.querySelector('.ne-qv__primary-img');
    var prev = section.querySelector('[data-qv-prev]');
    var next = section.querySelector('[data-qv-next]');
    if (!primaryImg) return;
    thumbs.forEach(function (thumb, idx) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) {
          t.classList.remove('ne-qv__thumb--active');
          t.setAttribute('aria-selected', 'false');
        });
        thumb.classList.add('ne-qv__thumb--active');
        thumb.setAttribute('aria-selected', 'true');
        var fullSrc = thumb.getAttribute('data-qv-full');
        swapPrimary(primaryImg, fullSrc, true);
        if (prev) prev.disabled = idx <= 0;
        if (next) next.disabled = idx >= thumbs.length - 1;
      });
    });
  }

  function wireSwatches(section) {
    var swatches = section.querySelectorAll('.ne-qv__swatch');
    swatches.forEach(function (sw) {
      sw.addEventListener('click', function () {
        var optionIdx = parseInt(sw.getAttribute('data-qv-option-index'), 10);
        var value = sw.getAttribute('data-qv-option-value');
        /* Update active state within this option group */
        var group = sw.closest('.ne-qv__swatches');
        if (group) {
          group.querySelectorAll('.ne-qv__swatch').forEach(function (s) {
            s.classList.remove('ne-qv__swatch--active', 'ne-product__btn-swatch--active');
            s.setAttribute('aria-checked', 'false');
          });
          sw.classList.add('ne-qv__swatch--active', 'ne-product__btn-swatch--active');
          sw.setAttribute('aria-checked', 'true');
        }
        /* Update displayed selected-value label */
        var label = sw.closest('.ne-qv__option').querySelector('.ne-qv__option-value');
        if (label) label.textContent = value;
        /* Resolve to variant + update form */
        resolveAndUpdate(section);
      });
    });
  }

  function getSelectedOptions(section) {
    var groups = section.querySelectorAll('.ne-qv__swatches');
    var opts = [];
    groups.forEach(function (g) {
      var active = g.querySelector('.ne-qv__swatch--active');
      if (active) opts.push(active.getAttribute('data-qv-option-value'));
    });
    return opts;
  }

  function resolveAndUpdate(section) {
    if (!currentVariants) return;
    var selected = getSelectedOptions(section);
    var match = null;
    for (var i = 0; i < currentVariants.length; i++) {
      var v = currentVariants[i];
      var vOpts = v.options || [v.option1, v.option2, v.option3].filter(Boolean);
      if (vOpts.length !== selected.length) continue;
      var ok = true;
      for (var j = 0; j < selected.length; j++) {
        if (vOpts[j] !== selected[j]) { ok = false; break; }
      }
      if (ok) { match = v; break; }
    }
    if (!match) return;

    /* Update hidden id input */
    var idInput = section.querySelector('[data-qv-variant-id]');
    if (idInput) idInput.value = match.id;

    /* Update price */
    var priceCurrent = section.querySelector('[data-qv-price-current]');
    var priceCompare = section.querySelector('[data-qv-price-compare]');
    if (priceCurrent) priceCurrent.textContent = formatMoney(match.price);
    if (priceCompare) {
      if (match.compare_at_price && match.compare_at_price > match.price) {
        priceCompare.textContent = formatMoney(match.compare_at_price);
        priceCompare.style.display = '';
        priceCurrent.classList.add('ne-qv__price-sale');
      } else {
        priceCompare.style.display = 'none';
        priceCurrent.classList.remove('ne-qv__price-sale');
      }
    }

    /* Update ATC button availability */
    var atc = section.querySelector('[data-qv-atc]');
    if (atc) {
      if (match.available) {
        atc.disabled = false;
        atc.textContent = 'Add to cart';
      } else {
        atc.disabled = true;
        atc.textContent = 'Sold out';
      }
    }

    /* If variant has a featured_image, swap primary image AND mark the
       matching thumb as active. Match by the variant image's id (or
       position) against the rendered thumbs' data-qv-full URL. */
    if (match.featured_image) {
      var primaryImg = section.querySelector('.ne-qv__primary-img');
      var thumbs = section.querySelectorAll('[data-qv-thumb]');
      var fullSrc = '';
      /* Prefer matching thumb by image id for accurate full-size URL */
      var imgId = match.featured_image.id;
      var matchedThumb = null;
      if (imgId && thumbs.length && currentProduct && currentProduct.media) {
        var mediaIdx = -1;
        for (var k = 0; k < currentProduct.media.length; k++) {
          var m = currentProduct.media[k];
          if (m.id === imgId || (m.preview_image && m.preview_image.id === imgId)) {
            mediaIdx = k; break;
          }
        }
        if (mediaIdx !== -1 && thumbs[mediaIdx]) {
          matchedThumb = thumbs[mediaIdx];
          fullSrc = matchedThumb.getAttribute('data-qv-full');
        }
      }
      /* Fallback: build URL from variant image src — Shopify CDN URLs
         accept _WIDTHx in path before extension. */
      if (!fullSrc && match.featured_image.src) {
        fullSrc = upsizeImageUrl(match.featured_image.src, 800);
      }
      swapPrimary(primaryImg, fullSrc);
      /* If the id match failed (variant image came via the URL fallback), find the
         thumbnail by comparing image URLs by their base — strip the Shopify CDN
         size suffix (_800x, _800x1000) and the ?v= query — so the preview strip's
         active state follows the colour swatch instead of sticking on the old image. */
      if (!matchedThumb && fullSrc) {
        var baseOf = function (u) {
          return (u || '').split('?')[0].replace(/_\d+x\d*(\.\w+)(?=$)/, '$1');
        };
        var target = baseOf(fullSrc);
        for (var z = 0; z < thumbs.length; z++) {
          if (baseOf(thumbs[z].getAttribute('data-qv-full')) === target) { matchedThumb = thumbs[z]; break; }
        }
      }
      if (matchedThumb) {
        thumbs.forEach(function (t) {
          t.classList.remove('ne-qv__thumb--active');
          t.setAttribute('aria-selected', 'false');
        });
        matchedThumb.classList.add('ne-qv__thumb--active');
        matchedThumb.setAttribute('aria-selected', 'true');
        matchedThumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
    }
  }

  /* Insert _800x before the file extension in a Shopify CDN URL.
     Handles query strings (?v=...) by inserting before the ? marker. */
  function upsizeImageUrl(url, width) {
    if (!url) return url;
    var size = '_' + width + 'x';
    /* Match: file.ext(?query)? — insert size before the dot+ext */
    return url.replace(/(\.[a-zA-Z]{3,4})(\?|$)/, size + '$1$2');
  }

  function formatMoney(cents) {
    if (window.Shopify && Shopify.formatMoney && window.theme && window.theme.moneyFormat) {
      return Shopify.formatMoney(cents, window.theme.moneyFormat);
    }
    /* Fallback — basic formatting */
    return (cents / 100).toFixed(2);
  }

  function wireQuantity(section) {
    var input = section.querySelector('[data-qv-qty-input]');
    var minus = section.querySelector('[data-qv-qty-minus]');
    var plus = section.querySelector('[data-qv-qty-plus]');
    if (!input) return;
    if (minus) minus.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      if (v > 1) input.value = v - 1;
    });
    if (plus) plus.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
    });
  }

  function wireForm(section, handle) {
    /* The form is wrapped in a div with [data-qv-form] (the wrapper
       carries the hook because Shopify's product-form tag breaks
       with custom data-attrs in args — Rule 180). Find the actual
       <form> inside it. */
    var wrap = section.querySelector('[data-qv-form]');
    var form = wrap ? wrap.querySelector('form') : null;
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var atc = form.querySelector('[data-qv-atc]');
      if (atc && atc.disabled) return;
      var originalText = atc ? atc.textContent : '';
      if (atc) { atc.disabled = true; atc.textContent = 'Adding...'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/javascript' },
        body: new FormData(form)
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data && data.id) {
            document.dispatchEvent(new CustomEvent('ne:cart-updated', { detail: { item: data } }));
            /* Brief success state then close */
            if (atc) atc.textContent = 'Added ✓';
            setTimeout(function () {
              closeQV();
              if (atc) { atc.disabled = false; atc.textContent = originalText || 'Add to cart'; }
            }, 600);
          } else {
            if (atc) { atc.disabled = false; atc.textContent = originalText || 'Add to cart'; }
            alert((data && data.description) || 'Could not add to cart.');
          }
        })
        .catch(function () {
          if (atc) { atc.disabled = false; atc.textContent = originalText || 'Add to cart'; }
          alert('Network error. Please try again.');
        });
    });
  }
})();
